import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import LabelReviewValidationModal from './LabelReviewValidationModal';
import { labelReviewSelectors, labelReviewTypes } from '../../../../redux/labelReview';
import { productSelectors } from '../../../../redux/product';
import { labelReviewValidationFormActions } from '../../../../redux/modal/LabelReviewValidationForm';
import { applicationSelectors } from '../../../../redux/application';
import { userSelectors } from '../../../../redux/user'

const LabelReviewValidationFormContainer = props => <LabelReviewValidationModal {...props} />;

const mapStateToProps = (state, { LabelReviewId, ProductId }) => {
  const currentUser = userSelectors.getCurrentUser(state);
  const labelReview = labelReviewSelectors.getLabelReview(state, LabelReviewId);
  const product = productSelectors.getProduct(state, ProductId);
  const title = `Label Review Validation (version ${get('RevisionNr', labelReview)}) For Product ${get(
    'ProductName',
    product,
  )}`;
  return {
    currentUser,
    title,
    isLoading: applicationSelectors.isLoading(state, labelReviewTypes.UPDATE_LABEL_REVIEW.REQUEST),
  };
};

const mapDispatchToProps = (dispatch, { LabelReviewId }) => ({
  onSave: data => {
    // console.log(data.currentuser.UserName)
    data.validatedBy = data.currentuser.UserName
    dispatch(labelReviewValidationFormActions.onSaveButtonClick({ LabelReviewId, ...data }))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LabelReviewValidationFormContainer);

LabelReviewValidationFormContainer.propTypes = {
  LabelReviewId: PropTypes.number.isRequired,
  ProductId: PropTypes.number.isRequired,
};
